export const COOKIE_ACCESS = "glucera_access_token";
export const COOKIE_USER_ID = "glucera_user_id";
export const COOKIE_USER_INFO = "glucera_user_info";

const COOKIE_MAX_AGE_SEC = 60 * 60 * 24 * 7; // 7 days

export type GluceraUserInfoCookie = {
  id: string;
  username?: string;
  email: string;
  full_name?: string;
  first_name?: string;
  last_name?: string;
  gender?: string;
  date_of_birth?: string | null;
  is_email_verified?: boolean;
  user_type?: string;
};

const cookieSecureSuffix = (): string =>
  typeof window !== "undefined" && window.location.protocol === "https:"
    ? "; Secure"
    : "";

const writeCookie = (name: string, value: string): void => {
  document.cookie = `${name}=${encodeURIComponent(value)}; path=/; max-age=${COOKIE_MAX_AGE_SEC}; SameSite=Lax${cookieSecureSuffix()}`;
};

export const setGluceraAuthCookies = (
  accessToken: string,
  userId?: string | null,
  userInfo?: unknown,
): void => {
  if (typeof document === "undefined") return;

  writeCookie(COOKIE_ACCESS, accessToken);

  if (userId) {
    writeCookie(COOKIE_USER_ID, userId);
  }

  if (userInfo && typeof userInfo === "object") {
    writeCookie(COOKIE_USER_INFO, JSON.stringify(userInfo));
  }
};

export const clearGluceraAuthCookies = (): void => {
  if (typeof document === "undefined") return;

  for (const name of [COOKIE_ACCESS, COOKIE_USER_ID, COOKIE_USER_INFO]) {
    document.cookie = `${name}=; path=/; max-age=0; SameSite=Lax${cookieSecureSuffix()}`;
  }
};

export const getGluceraUserIdFromStorage = (): string | null => {
  try {
    const token = localStorage.getItem("glucera_access_token");
    if (token) {
      const payload = token.split(".")?.[1];
      if (payload) {
        const decoded = JSON.parse(atob(payload)) as {
          user_id?: string;
          userId?: string;
        };
        const fromToken = decoded.user_id || decoded.userId;
        if (fromToken) return fromToken;
      }
    }

    const raw = localStorage.getItem("glucera_user_info");
    if (raw) {
      const user = JSON.parse(raw) as { id?: string };
      if (user.id) return user.id;
    }
  } catch {
    // ignore
  }
  return null;
};
